import { Currency } from '@/core/currency/interfaces';

const SCR: Currency = {
    name: 'Seychellois Rupee',
    demonym: 'Seychellois',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '690',
    symbol: 'Rs.',
    symbolNative: 'Rs',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SCR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SCR;
